import claimResource from "@/shared/resource/claim";
import { authorizedAxios } from "./authorizedAxios";
import { ClaimResponse,
  ExpenseLinkRequest,
  ClaimLinkRequest,
  ClaimExpenseLinkRemoveRequest,
  LinkedExpense,
  LinkedClaim,
  Claim,
  HPHCOptInRequest
} from "@/shared/types";

export function getClaims (
  pageNumber: number,
  size: number,
  date: string,
  provider: string,
  expenseId: number) {

  const query = {
    page: pageNumber,
    pageSize: size,
    serviceDate: date,
    providerName: provider,
    excludeLinkedToExpenseId: expenseId};

  return authorizedAxios.get<ClaimResponse>(
    claimResource.getClaims(),
    query
  );
}

export function getLinkedExpenses (
  claim: string) {
  const query = { claimNumber: claim };

  return authorizedAxios.get<LinkedExpense[]>(claimResource.getLinkedExpenses(), query);
}

export function getClaimLinksByExpense (
  expenseIdParam: number) {
  const query = { expenseId: expenseIdParam };

  return authorizedAxios.get<LinkedClaim[]>(claimResource.getClaimLinksByExpense(), query);
}

export function getLinkedClaims (
  expenseIdParam: number) {
  const query = { expenseId: expenseIdParam };

  return authorizedAxios.get<Claim[]>(claimResource.getLinkedClaims(), query);
}

export function linkExpenseToClaims (request: ExpenseLinkRequest) {
  return authorizedAxios.post(claimResource.linkExpenseToClaims(), request);
}

export function linkClaimToExpenses (request: ClaimLinkRequest) {
  return authorizedAxios.post(claimResource.linkClaimToExpenses(), request);
}

export function userHasThirdPartyClaims () {
  return authorizedAxios.get<boolean>(claimResource.userHasThirdPartyClaims());
}

export function removeClaimExpenseLink (request: ClaimExpenseLinkRemoveRequest) {
  return authorizedAxios.delete(claimResource.removeClaimExpenseLink(request.claimNumber, request.expenseId));
}

export function removeLinksToExpense (expenseId: number) {
  return authorizedAxios.delete(claimResource.removeLinksToExpense(expenseId));
}

export function optInHPHC (r: HPHCOptInRequest) {
  return authorizedAxios.post<boolean>(claimResource.optInHPHC(), r);
}

export function isOptedIn () {
  return authorizedAxios.get<boolean>(claimResource.optInHPHC());
}

export function optOutHPHC () {
  return authorizedAxios.get<boolean>(claimResource.optOutHPHC());
}

export function hasClaims () {
  return authorizedAxios.get<boolean>(claimResource.hasClaims());
}

export function getPartnerSettings (partnerId: number) {
  return authorizedAxios.get<any>(claimResource.partnerSettings(partnerId));
}

export function savePartnerSettings (partnerId: number, discardMmsClaims: boolean) {
  return authorizedAxios.post<any>(claimResource.partnerSettings(partnerId), { discardMmsClaims });
}